import type { FaireProductEntity } from "../../entity_types/product";

export const p_y9xv3apx64: FaireProductEntity = {
  token: "p_y9xv3apx64",
  type: "product",
  name: "Mini Crystal Oval Thumb Worry Stones - Choose from 10",
  brandToken: "b_kznjgqp8wa",
  brandName: "Calder Crystals",
  imageUrl: "https://cdn.faire.com/fastly/6e4f5980b111cd276006a08f94aa0b6e6f13686a079ef375460781d745df7772.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8e79d88bebc2b25eea36257fe8ff2049b643cf1fafe1ad41a82bf3c7146d7bb2.jpeg",
    "https://cdn.faire.com/fastly/0a9e64fe74a6d990235b696bf986979d9c0416e1c8c9a8fa0603bf5eb8e98cb9.jpeg",
    "https://cdn.faire.com/fastly/e9d55bb72ae35f0fd01c32058661138a4a43eda370b70c394d166e73fe72c5dc.jpeg",
    "https://cdn.faire.com/fastly/4316e293687894fcee18dc7498c038c9c852ae1be76acef9a057ee8bd4ad3447.jpeg",
    "https://cdn.faire.com/fastly/9ec238ca0f82be3a68068698a27dffb8525ce55a46725f85c4777c431f848cec.jpeg",
    "https://cdn.faire.com/fastly/1e1f35bd8de60ec0380993013d95de3afc117492092aac5f0ec66c25a9bf3765.jpeg",
    "https://cdn.faire.com/fastly/620a6055a90a0da0e23ea220cbfb36dfede3846fec388ed61c68601e0a1eadb4.jpeg",
    "https://cdn.faire.com/fastly/8efe7e18c05c21b4c2c11b0c4ee52034b46029768b2fa5c27079350a54871c43.jpeg",
    "https://cdn.faire.com/fastly/0b75c6190334c3d34ceb90c299c9ccc05d02ce3c0c7460892a9ecc99883b4aa3.jpeg",
    "https://cdn.faire.com/fastly/8286c79c8713c249e5eaec45110998ab41ac49f7099f82f19dcbf998dc39c87f.jpeg"
  ],
  priceDollars: 0.92,
  description: "Natural Polished Mini Oval Palm / Thumb Worry Stone Gemstones\n\nQuantity: 1 worry stone, will be randomly hand-picked and packed for you, each single piece is beautiful with its own unique colour and markings.\n\nPlease choose your stone option from the drop-down menu\n\nSize: Approx 0.6cm in height x 2.2cm in width x 2.6cm in depth\n\nWeight: Approx 7 - 8 grams per oval\n\nCare has been taken to ensure that weights and measurements are as accurate as possible, however please do note that these are only approximate.\n\nThese are carved from natural stone so they are not perfect and flawless. Natural inclusions, cracks and pockets are all visible and all part of the natural stone.\n\nPlease choose from the following stones: 1. Green Aventurine\n2. Black Obsidian\n3. Yellow Calcite\n4. Chevron Amethyst\n5. Yellow Jade\n6. Clear Quartz\n7. Rose Quartz\n8. Lapis Lazuli\n9. Tiger Eye\n10. Brown Banded Agate",
  tags: [],
  msrpDollars: 1.84,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:12.758Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
